export const getbranch = `
query GetBranchById($id: ID!) {
  getBranchById(id: $id) {
    success
    error
    message
    branch {
      id
      branchName
      branchCode
      address1
      address2
      pincode
      country
      state
      city
      gstNumber
      panNumber
      ifscCode
      companyName {
        id
        companyName
      }
      contactInfo {
        id
        salutation
        name
        designation
        phoneNumber
        email
      }
    }
  }
}

`

export const getcompany = `
query {
  getCompany {
    success
    error
    message
    company {
      id
      companyName
      address1
      address2
      country
      pincode
      state
      city
      ownershipType
      incorporationDate
      gstNumber
      cinNumber
      ifscCode
      contactInfo{
        id
        salutation
        name
        designation
        phoneNumber
        email
      }
    }
  }
}

`

export const getallbranch = `
query {
  getAllBranch {
    success
    error
    message
    branch {
      id
      branchName
      branchCode
      address1
      address2
      pincode
      country
      state
      city
      gstNumber
      panNumber
      ifscCode
      companyName {
        id
        companyName
      }
      contactInfo {
        id
        salutation
        name
        designation
        phoneNumber
        email
      }
    }
  }
}

`